import * as React from 'react'
import { dateOptions } from '../../../constants'
import { type IFilterMode, LimitedDateFilter } from '@user/components/Filters'

export function CreatedDateFilter(props: IFilterMode) {
  return (
    <LimitedDateFilter
      {...props}
      name="createdDate"
      label="Created Date"
      options={dateOptions}
    />
  )
}
